import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { toast } from 'react-toastify';
import axios from 'axios';
import CustomBackdrop from '../../../../components/backdrop';
import getEnvironement from '../../../../environnement';

export default function DeleteDialog({
  open,
  handleClose,
  reloadData,
  departementData,
}) {
  const [openBackdrop, setOpenBackdrop] = useState(false);

  async function deleteDepartement() {
    const url = `${getEnvironement().API_URL}/departements/${departementData.id}`;
    handleClose();
    setOpenBackdrop(true);
    await axios.delete(url)
      .then(() => setTimeout(() => setOpenBackdrop(false), 800))
      .then(() => reloadData())
      .then(() => setTimeout(() => toast.success('Le département a bien été supprimé'), 800))
      .catch((err) => {
        setOpenBackdrop(false);
        if (err.response.data.message && err.response.status === 402) {
          toast.error('une réservation utilise déjà ce département. Merci de la supprimer avant de continuer');
        }
      });
  }

  return (
    <>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{paddingBottom: '0px'}}
      >
        <DialogTitle id="alert-dialog-title">
          <p className='text-2xl sm:text-3xl font-medium font-inter mt-5'>Département : {departementData?.departement}</p>
          
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <p className='text-2xl sm:text-3xl font-medium font-inter mt-5'>Voulez vous vraiment supprimer ce département. il sera supprimer définitivement</p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='flex justify-between px-5 w-full gap-5'>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={handleClose}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Annuler</p>
            </div>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={deleteDepartement}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Supprimer</p>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
